import * as types from '../mutations'
import { APP } from '../../constants'

const state = {
  history: [],
  currentLot: [],
}

const mutations = {
  [types.LIVE_WIDGET_HISTORY_INIT]: (state, bids) => {
    // console.log('am ajuns in initialize mutation history');
    // state.history = new Array();
  },
  [types.LIVE_WIDGET_LOT_PUBLISHED]: (state, bids) => {
    state.history = new Array();
  },
  [types.LIVE_WIDGET_ADD_TO_HISTORY]: (state, bids) => {
    console.log('ajuns aici');
    state.history.push(bids);
    state.history.reverse();
  },
  [types.KEEP_HISTORY_ALIVE]: (state, bids) => {
    //getting only the 'bid:received' events data'
    let history = bids.history.filter(function (bid) {
      return bid.type === 'bid:processed';
    });
    //arrange by date then reverse
    history.sort((a,b) => (a.ts > b.ts) ? 1 : ((b.ts > a.ts) ? -1 : 0));
    history.reverse();
    history.forEach(function(bid) {
      console.log('aici');
      state.history.push(bid.data);
    });


  },
}

const getters = {
  liveWidgetHistory: (state) => state.history,
}

export default {
  state,
  mutations,
  getters
}
